import { useMemo } from "react";
import { config } from '@/config';
import { createLogger } from '@/lib/logger';

/**
 * Prefixes the component name to logs
 * @param {*} componentName 
 * @returns 
 * Usage
 * const logger = useComponentLogger("Component Name");
 * logger.debug('debug msg')
 * should print "[DEBUG Component Name] debug msg "
 */
export function useComponentLogger(componentName) {
  return useMemo(() => createLogger({ prefix: componentName, level: config.logLevel }), [componentName]);
}
